import { flow, get, groupBy, map, mapValues, values } from 'lodash/fp';

import decodePlayer from './decodePlayer';
import decodeTeam from './decodeTeam';

const normalizePlayerSelections = flow(
  groupBy('position.key'),
  mapValues(group => ({
    abbr: get('position.short_label', group[0]),
    entities: map(decodePlayer, group),
    id: get('position.key', group[0]),
    name: get('position.label', group[0])
  })),
  values
);

const normalizeTeamSelections = flow(
  groupBy('position.key'),
  mapValues(group => ({
    abbr: get('position.short_label', group[0]) || get('position.abbr', group[0]),
    entities: map(decodeTeam, group),
    id: get('position.key', group[0]),
    name: get('position.label', group[0])
  })),
  values
);

function decodeChallengeEntrySelection(data = {}) {
  return [...normalizePlayerSelections(data.players), ...normalizeTeamSelections(data.teams)];
}

export default decodeChallengeEntrySelection;
